import React,{useState} from 'react';
import {Navbar,Nav} from 'react-bootstrap';
import {RAjax} from '@putil-view/request.r-ajax';
import {FaHome,FaPrint,FaCheckDouble,FaListAlt,FaSignOutAlt,FaUnlock,FaLock,FaBroom} from 'react-icons/fa';
import { LinkContainer } from 'react-router-bootstrap';
import {SysPath} from 'SysContext';
import PropTypes from 'prop-types';
import "css/r-nav.css";
import "css/r-link.css";

const NavLogoutLink = () =>{
	const [status, setStatus] = useState("USER_LOGINED");
	return (
			<>
			<Nav.Link eventKey="5" style={{paddingBottom:'10px'}} className="fade-in qr-nav-link nav-link bg-custom-green "  onClick={()=> setStatus("USER_LOGOUT")}>
				<FaSignOutAlt className="r-nav-icon"/>
				<span className="r-nav-text" style={{paddingLeft:'5px'}}>Logout</span>
			</Nav.Link>
			{status === "USER_LOGOUT"
				?
					<RAjax requestOptions={{
								method: 'get',
								withCredentials: true,
								url: SysPath.logoutUrl
							}}
							handleResponse={() => {
								window.history.replaceState({}, document.title , window.location.protocol+ "//" + window.location.host+'/');
								window.location.replace(SysPath.polyuSignOutUrl)
							}}
					/>
				:
					false
			}
			</>
	)

}
const NavBarLink = (props) => {
	const to = props.to;
	const eventKey = props.eventKey;
	const children = props.children;
	return (
		<LinkContainer style={{paddingBottom:'10px'}}  to={to}>
			<Nav.Link eventKey={eventKey} className="fade-in qr-nav-link nav-link bg-custom-green ">
					{children}
			</Nav.Link>
		</LinkContainer>
	)
}
NavBarLink.propTypes = {
	to: PropTypes.string,
	eventKey: PropTypes.string,
	children: PropTypes.node,
};

const NavBar = (props) => {

		const role = props.role;
		let views;

		switch(role){
			case "elocker_admin":
				views =
					<>

					<NavBarLink to="/match" eventKey="3">
						<FaCheckDouble className="r-nav-icon"/>
						<span className="r-nav-text" style={{ paddingLeft:'5px'}}>Match</span>
					</NavBarLink>
					<NavBarLink to="/unlock" eventKey="3">
						<FaUnlock className="r-nav-icon"/>
						<span className="r-nav-text" style={{ paddingLeft:'5px'}}>Unlock</span>
					</NavBarLink>
					<NavBarLink to="/print?mode=card&type=lock" eventKey="3">
						<FaPrint className="r-nav-icon"/>
						<span className="r-nav-text" style={{ paddingLeft:'5px'}}>Print</span>
					</NavBarLink>
					<NavBarLink to="/unclear" eventKey="3">
						<FaLock className="r-nav-icon" fill="rgb(255,255,255)"/>
						<span className="r-nav-text" style={{ paddingLeft:'5px'}}>Unclear</span>
					</NavBarLink>
					<NavBarLink to="/clear" eventKey="3">
						<FaBroom className="r-nav-icon" fill="rgb(255,255,255)"/>
						<span className="r-nav-text" style={{ paddingLeft:'5px'}}>Clear</span>
					</NavBarLink>
					<NavBarLink to="/manage" eventKey="3">
						<FaListAlt className="r-nav-icon"/>
						<span className="r-nav-text" style={{ paddingLeft:'5px'}}>Manage</span>
					</NavBarLink>
					
					<NavLogoutLink/>
					</>
			break;
			case "user":
				views =<NavLogoutLink/>
			break;
			default:
				views =
					<>
					<NavLogoutLink/>
					</>
			break;
		}

		return (
			<Navbar collapseOnSelect  fixed="top" expand="lg" className=" navbar-dark bg-custom-green fade-in" style={{padding:'0px'}}>
				<Navbar.Brand style={{textAlign: 'center'}}  className="nav-link" href="/">
					<FaHome className="r-nav-icon"/>
					<span className="r-nav-text"style={{paddingLeft:'5px'}}>Home</span>
				</Navbar.Brand>
								<Navbar.Toggle className="r-nav-icon" aria-controls="responsive-navbar-nav" style={{paddingBottom:'10px',paddingTop:'10px',outline: 'none',marginRight:'10px'}}/>
				<Navbar.Collapse id="responsive-navbar-nav">
				<Nav className="mr-auto"/>
					<Nav>
						{views}
					</Nav>
				</Navbar.Collapse>
			</Navbar>

		);

}
NavBar.propTypes = {
	role: PropTypes.string
};
export default NavBar;
